<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row justify-content-center">
              <button class="btn btn-add" v-if="$store.state.user.access_nivel == 2" id="v-step-0" @click="startTour">
                Iniciar Tour na Pagína ínicial
              </button>
            </div>
            <br />
            <div id="v-step-30"></div>
            <div class="alert alert-primary" role="alert">
              <strong>Para utilizar o filtro corretamente, basta colocar uma Data
                Inicial, Data Final, Selecionar uma Empresa e Filial.</strong>
            </div>
            <br />
            <div class="card-title">Filtros</div>
          </div>
          <div class="card-body">
            <form action="">
              <div class="row">
                <div class="form-group col-md-2" id="v-step-1">
                  <label for="inputDateIn"> Data Inicial </label>
                  <input type="date" class="form-control" id="inputDateIn" v-model="filters.date_start" />
                </div>
                <div class="form-group col-md-2" id="v-step-2">
                  <label for="inputDateOut"> Data Final </label>
                  <input type="date" class="form-control" id="inputDateOut" v-model="filters.date_end" />
                </div>
                <div class="form-group col-md-3" id="v-step-3">
                  <label for="selectEmpr"> Selecione uma empresa </label>
                  <select v-model="filters.company_id" class="form-control" id="selectEmpr">
                    <option v-for="company in companies" :value="company.id" :key="company.id">
                      {{ company.company_name_fantasy }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3" id="v-step-4">
                  <label for="selectFil"> Selecione uma filial </label>
                  <select v-model="filters.branch_id" class="form-control" id="selectFil">
                    <option v-for="branch in branches" :value="branch.id" :key="branch.id">
                      {{ branch.title }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <a class="btn btn-main btn-block" @click="getCountHighlights" id="v-step-5">Filtrar</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Widgets -->
    <div class="row justify-content-md-center">
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info" id="v-step-6">Salas Cadastradas</div>
            <div class="card-value-info">{{ countHighlights.countRooms }}</div>

            <i class="fas fa-door-open card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info" id="v-step-7">
              Estações Cadastradas
            </div>
            <div class="card-value-info">
              {{ countHighlights.countWorkstations }}
            </div>

            <i class="fas fa-network-wired card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info" id="v-step-8">
              Usuários Cadastrados
            </div>
            <div class="card-value-info">{{ countHighlights.countUsers }}</div>

            <i class="fas fa-users card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info" id="v-step-9">Salas Reservadas</div>
            <div class="card-value-info">
              {{ countHighlights.countRoomReservations }}
            </div>

            <i class="fas fa-door-open card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info" id="v-step-10">
              Estações Reservadas
            </div>
            <div class="card-value-info">
              {{ countHighlights.countWorkstationReservations }}
            </div>

            <i class="fas fa-network-wired card-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center" v-if="$store.state.user.access_nivel == 3">
      <div class="col-md-3">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Empresas Cadastradas</div>
            <div class="card-value-info">
              {{ countHighlights.countCompanies }}
            </div>

            <i class="far fa-building card-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-11">
            <div class="card-title">Salas Mais Reservadas</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getMostBookedRooms"
                  :options="options1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-12">
            <div class="card-title">
              Estações mais reservadas
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getMostBookedWorkstations"
                  :options="options2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-11">
            <div class="card-title">Usuários que mais reservam salas</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getMostBookedRoomsByUser"
                  :options="options1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-12">
            <div class="card-title">
              Usuários que mais reservam estações
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getMostBookedWorkstationsByUser"
                  :options="options2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-11">
            <div class="card-title">Salas de reunião - Status de reserva</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getRoomCharts"
                  :options="options1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-12">
            <div class="card-title">
              Salas de reunião - Taxa de ocupação atual
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getRoomOccupationCharts"
                  :options="options2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-13">
            <div class="card-title">
              Estação de Trabalho - Status de reserva
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getWorkstationCharts"
                  :options="options1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header" id="v-step-14">
            <div class="card-title">
              Estação de Trabalho - Taxa de ocupação atual
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar id="Chart1" v-if="load" class="centered" :chart-data="dash.getWorkstationOccupationCharts"
                  :options="options2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartBar from "@/components/Utils/ChartBar.js";

export default {
  name: 'Dashboard',
  data() {
    return {
      options1: {
        minBarLength: 0,
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        pieceLabel: {
          mode: "percentage",
          precision: 1,
        },
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      options2: {
        minBarLength: 0,
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        pieceLabel: {
          mode: "percentage",
          precision: 1,
        },
        scales: {
          xAxes: [
            {
              stacked: false,
            },
          ],
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      countHighlights: {
        countRooms: 0,
        countWorkstations: 0,
        countUsers: 0,
        countRoomReservations: 0,
        countWorkstationReservations: 0,
        countCompanies: 0,
      },
      filters: {
        date_start: "",
        date_end: "",
        company_id: "",
        branch_id: "",
      },
      companies: [],
      branches: [],
      home: [],
      load: false,
      dash: {},
      steps: [
        {
          target: "#v-step-0",
          header: {
            title: "Bem vindo ao Invitee!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Aqui iniciamos os filtros dos gráficos abaixo, selecione uma Data Inicial",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content: "Selecione uma Data Final",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Selecione uma Empresa",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Selecione uma Filial",
        },
        {
          target: "#v-step-5",
          content: "E basta clicar em Filtrar.",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-6",
          content: "Aqui são todas as Salas Cadastradas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-7",
          content: "Aqui são todas as Estações Cadastradas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-8",
          content: "Aqui são todas os Usuários Cadastradas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-9",
          content: "Aqui são todas as Salas Reservadas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-10",
          content: "Aqui são todas as Estações Cadastradas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-11",
          content:
            "Aqui temos um gráfico de Salas de Reunião, onde mostra quais os status das reservas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-12",
          content:
            "Aqui temos um gráfico de Salas de Reunião, onde mostra qual a taxa de ocupação atual",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-13",
          content:
            "Aqui temos um gráfico de Estações de Trabalho, onde mostra quais os status das reservas",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-14",
          content:
            "Chegamos na última parte da primeira tela do tour :). Aqui temos um gráfico de Estações de Trabalho, onde mostra qual a taxa de ocupação atual",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="15"]',
          content: "Clique em cadastros.",
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="16"]',
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar sua Empresa.",
        },
        {
          target: "#v-step-17",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar suas Filiais.",
        },
        {
          target: "#v-step-18",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar os Departamentos.",
        },
        {
          target: "#v-step-19",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar os Adicionais de Sala.",
        },
        {
          target: "#v-step-20",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar os Adicionais de Estação.",
        },
        {
          target: "#v-step-21",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar as Salas de Reuniões.",
        },
        {
          target: "#v-step-22",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar as Estações de Trabalho.",
        },
        {
          target: "#v-step-23",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar os Usuários.",
        },
        {
          target: "#v-step-24",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content: "Aqui você poderá gerenciar os Serviçoes Adicionais.",
        },
        {
          target: "#v-step-25",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content:
            "Em Reservar Sala você pode fazer uma Reserva de Sala de Reunião.",
        },
        {
          target: "#v-step-26",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content:
            "Em Reservar Estação de Trabalho você pode fazer uma Reserva de Estação de Trabalho.",
        },
        {
          target: "#v-step-27",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content:
            "Em Serviços Adicionais você poderá cadastrar serviços para utilizar nas reservas.",
        },
        {
          target: "#v-step-28",
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content:
            "Em Chamados Internos você pode verificar se há chamados nas reservas.",
        },
        {
          target: '[data-v-step="29"]',
          params: {
            enableScrolling: false,
            placement: "right",
          },
          content:
            "Em Exportação Excel você pode exportar Reservas de Sala de Reunião ou Estação de Trabalho.",
        },
        {
          target: "#v-step-30",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Aqui finalizamos o Tour da Home, em cada página teremos um tour para guia-lo da melhor maneira possível. Tenha uma excelente experiência utilizando a plataforma.",
        },
      ],
    };
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => { });
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 14) {
        if (step >= 16) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 14) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 15) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 29) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    getCountHighlights: function () {
      const self = this;
      const api = self.$store.state.api + "countHighlights";

      this.load = false;

      let fd = {
        date_start: self.filters.date_start,
        date_end: self.filters.date_end,
        company: self.filters.company_id,
        branch: self.filters.branch_id,
      };

      self.$http
        .post(api, fd)
        .then((response) => {
          self.countHighlights.countRooms =
            response.data.getCountHighlights.countRooms;
          self.countHighlights.countWorkstations =
            response.data.getCountHighlights.countWorkstations;
          self.countHighlights.countUsers =
            response.data.getCountHighlights.countUsers;
          self.countHighlights.countRoomReservations =
            response.data.getCountHighlights.countRoomReservations;
          self.countHighlights.countWorkstationReservations =
            response.data.getCountHighlights.countWorkstationReservations;
          self.countHighlights.countCompanies =
            response.data.getCountHighlights.countCompanies;
          self.countHighlights.getMostBookedRooms = response.data.getMostBookedRooms;
          self.countHighlights.getMostBookedWorkstations = response.data.getMostBookedWorkstations;
          self.countHighlights.getMostBookedRoomsByUser = response.data.getMostBookedRoomsByUser;
          self.countHighlights.getMostBookedWorkstationsByUser = response.data.getMostBookedWorkstationsByUser;

          self.home = response.data;
          self.getRoomCharts();
          console.log('1');
          self.getRoomOccupationCharts();
          console.log('2');
          self.getWorkstationCharts();
          console.log('3');
          self.getWorkstationOccupationCharts();
          console.log('4');
          self.getMostBookedRooms();
          console.log('5');
          self.getMostBookedWorkstations();
          console.log('6');
          self.getMostBookedRoomsByUser();
          console.log('7');
          self.getMostBookedWorkstationsByUser();
          console.log('8');

          console.log('cheguei');
          this.load = true;
        })
        .catch((error) => {
          self.$message(null, "Erro", "error");
        });
    },

    getMostBookedRoomsByUser: function (roomChartData) {

      try {
        const self = this;

        const color1 = "#000000"; //Black
        const color2 = "#333333"; //Gray 01
        const color3 = "#666666"; //Gray 02
        const color4 = "#999999"; //Gray 03
        const color5 = "#cccccc"; //Gray 04
        const color6 = "#55efc4"; //Green
        const color7 = "#74b9ff"; //Blue
        const color8 = "#a29bfe"; //Purple
        const color9 = "#ffeaa7"; //Yellow
        const color10 = "#fab1a0"; //Orange
        const color11 = "#ff7675"; //Red

        function convertHex(hex, opacity) {
          hex = hex.replace("#", "");
          const r = parseInt(hex.substring(0, 2), 16);
          const g = parseInt(hex.substring(2, 4), 16);
          const b = parseInt(hex.substring(4, 6), 16);

          return `rgba(${r},${g},${b},${opacity / 100})`;
        }

        self.dash.getMostBookedRoomsByUser = {
          labels: self.home.getMostBookedRoomsByUser.labels,
          datasets: [
            {
              label: "Quantidade das salas reservadas",
              borderColor: convertHex(color6, 100),
              borderWidth: 2,
              backgroundColor: convertHex(color6, 5),
              data: self.home.getMostBookedRoomsByUser.data,
            },

          ],
        };
      } catch (e) {
        console.log(e);
      }

    },

    getMostBookedWorkstationsByUser: function (roomChartData) {

      try {
        const self = this;

        const color1 = "#000000"; //Black
        const color2 = "#333333"; //Gray 01
        const color3 = "#666666"; //Gray 02
        const color4 = "#999999"; //Gray 03
        const color5 = "#cccccc"; //Gray 04
        const color6 = "#55efc4"; //Green
        const color7 = "#74b9ff"; //Blue
        const color8 = "#a29bfe"; //Purple
        const color9 = "#ffeaa7"; //Yellow
        const color10 = "#fab1a0"; //Orange
        const color11 = "#ff7675"; //Red

        function convertHex(hex, opacity) {
          hex = hex.replace("#", "");
          const r = parseInt(hex.substring(0, 2), 16);
          const g = parseInt(hex.substring(2, 4), 16);
          const b = parseInt(hex.substring(4, 6), 16);

          return `rgba(${r},${g},${b},${opacity / 100})`;
        }

        self.dash.getMostBookedWorkstationsByUser = {
          labels: self.home.getMostBookedWorkstationsByUser.labels,
          datasets: [
            {
              label: "Quantidade das salas reservadas",
              borderColor: convertHex(color6, 100),
              borderWidth: 2,
              backgroundColor: convertHex(color6, 5),
              data: self.home.getMostBookedWorkstationsByUser.data,
            },

          ],
        };
      } catch (e) {
        console.log(e);
      }

    },

    getMostBookedRooms: function (roomChartData) {

      try {
        const self = this;

        const color1 = "#000000"; //Black
        const color2 = "#333333"; //Gray 01
        const color3 = "#666666"; //Gray 02
        const color4 = "#999999"; //Gray 03
        const color5 = "#cccccc"; //Gray 04
        const color6 = "#55efc4"; //Green
        const color7 = "#74b9ff"; //Blue
        const color8 = "#a29bfe"; //Purple
        const color9 = "#ffeaa7"; //Yellow
        const color10 = "#fab1a0"; //Orange
        const color11 = "#ff7675"; //Red

        function convertHex(hex, opacity) {
          hex = hex.replace("#", "");
          const r = parseInt(hex.substring(0, 2), 16);
          const g = parseInt(hex.substring(2, 4), 16);
          const b = parseInt(hex.substring(4, 6), 16);

          return `rgba(${r},${g},${b},${opacity / 100})`;
        }

        self.dash.getMostBookedRooms = {
          labels: self.home.getMostBookedRooms.labels,
          datasets: [
            {
              label: "Quantidade das salas reservadas",
              borderColor: convertHex(color6, 100),
              borderWidth: 2,
              backgroundColor: convertHex(color6, 5),
              data: self.home.getMostBookedRooms.data,
            },

          ],
        };
      } catch (e) {
        console.log(e);
      }

    },

    getMostBookedWorkstations: function (roomChartData) {
      const self = this;

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r},${g},${b},${opacity / 100})`;
      }

      // Usa os dados passados em roomChartData
      self.dash.getMostBookedWorkstations = {
        labels: self.home.getMostBookedWorkstations.labels,
        datasets: [
          {
            label: "Quantidade das salas reservadas",
            borderColor: convertHex(color6, 100),
            borderWidth: 2,
            backgroundColor: convertHex(color6, 5),
            data: self.home.getMostBookedWorkstations.data,
          },

        ],
      };
    },

    getRoomCharts: function () {
      const self = this;
      // Chart 01: Salas de reunião - Status de reserva

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";

        return result;
      }

      self.dash.getRoomCharts = {
        labels: self.home.getRoomChart.labels,
        datasets: [
          {
            label: "Qtde. Reservas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: self.home.getRoomChart.reserves,
          },
          {
            label: "Realizadas",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: self.home.getRoomChart.finishedReserves,
          },
          {
            label: "Não Realizadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: self.home.getRoomChart.canceledReserves,
          },
        ],
      };
    },

    getRoomOccupationCharts: function () {
      const self = this;
      // Chart 02: Salas de reunião - Taxa de ocupação atual

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
        return result;
      }

      self.dash.getRoomOccupationCharts = {
        labels: self.home.getRoomOccupationChart.labels,
        datasets: [
          {
            label: "Disponíveis",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: [self.home.getRoomOccupationChart.availables],
          },
          {
            label: "Reservadas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: [self.home.getRoomOccupationChart.reserved],
          },
          {
            label: "Ocupadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: [self.home.getRoomOccupationChart.busy],
          },
        ],
      };
    },

    getWorkstationCharts: function () {
      const self = this;
      // Chart 03: Estação de Trabalho - Status de reserva

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
        return result;
      }

      self.dash.getWorkstationCharts = {
        labels: self.home.getWorkstationChart.labels,
        datasets: [
          {
            label: "Qtde. Reservas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: self.home.getWorkstationChart.reserves,
          },
          {
            label: "Realizadas",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: self.home.getWorkstationChart.finishedReserves,
          },
          {
            label: "Não Realizadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: self.home.getWorkstationChart.canceledReserves,
          },
        ],
      };
    },

    getWorkstationOccupationCharts: function () {
      const self = this;
      // Chart 04: Estação de Trabalho - Taxa de ocupação atual

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
        return result;
      }

      self.dash.getWorkstationOccupationCharts = {
        labels: self.home.getWorkstationOccupationChart.labels,
        datasets: [
          {
            label: "Disponíveis",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: [self.home.getWorkstationOccupationChart.availables],
          },
          {
            label: "Reservadas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: [self.home.getWorkstationOccupationChart.reserved],
          },
          {
            label: "Ocupadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: [self.home.getWorkstationOccupationChart.busy],
          },
        ],
      };
    },

    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: {
    ChartBar,
  },
  mounted: function () {
    const self = this;
    setTimeout(function () {
      if (self.$store.state.tour == true) {
        setTimeout(function () {
          self.$tours["myTour"].start();
        }, 1000);
      }
    }, 2000);
    self.getCountHighlights();
    self.getCompanies();
    self.getBranches();
  },
};
</script>

<style scoped>
form {
  margin-block-end: unset;
}

.btn-reserve:hover,
.btn-reserve[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.activeMenu {
  background-color: #4b2e8f !important;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue